import React from 'react';
import { isUnicode } from './text';

import './textarea.css'

export default function TextArea({
    value,
    setValue,
    length,
    rows = 7,
    spellCheck = false,
    label = '',
    placeholder = '',
    size = 'large'
}) {
    return (
        <div className='textareagroup'>
            <div className='textarealabel'>{label}</div>
            <textarea
                className={size == 'large' ? 'textarea textarea_large' : 'textarea textarea_small'}
                rows={rows}
                maxLength={length}
                onChange={e => setValue(e.target.value)}
                value={value}
                required
                spellCheck={spellCheck}
                dir={isUnicode(value) ? 'rtl' : 'auto'}
                placeholder={placeholder}
            />
            {length && (<div className='textarealength'>{value?.length || 0} / {length}</div>)}
        </div>
    );
}